import React from 'react'

function Search() {
  return (
    <>
      <div className='search pb-4'>
        <input type="text" name='search' placeholder='Search...'/>
      </div>
    </>
  )
}

export default Search